import gql from 'graphql-tag'
import { EnumFields } from '..'

// TODO: include [icon, color] when available
export const RentTypeFragment = gql`
  fragment RentType on persons_rent_type {
    ${EnumFields}
  }
`
